import { render } from "./NewsForCapital.vue?vue&type=template&id=1d226704&scoped=true"
import script from "./NewsForCapital.vue?vue&type=script&lang=js"
export * from "./NewsForCapital.vue?vue&type=script&lang=js"

import "./NewsForCapital.vue?vue&type=style&index=0&id=1d226704&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d226704"]])

export default __exports__